import React from 'react'

import { registerSlide } from '../registry'
import { FindingExhibitSlide } from './FindingExhibitSlide'
import type { FindingExhibitData } from './types'

type LiveExhibit = FindingExhibitData

/** One renderer for all admitted evidence compositions. */
for (const type of [
  'evidence-single',
  'evidence-rail',
  'evidence-pair',
  'evidence-multiples',
  'metric-callout',
  'respondent-feature',
] as const) {
  registerSlide(type, (props: Omit<Extract<LiveExhibit, { type: typeof type }>, 'type'>) => (
    <FindingExhibitSlide data={{ ...props, type } as LiveExhibit} />
  ))
}
